export const PROVIDER_LABELS: Record<string, string> = { stripe: 'Stripe', paypal: 'PayPal', authnet: 'Authorize.Net', offline: 'Check' }
export function providerLabel(source: string | null | undefined): string {
  return (source && PROVIDER_LABELS[source]) ?? source ?? '—'
}

export function fmtInt(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—'
  return n.toLocaleString('en-US')
}

export function fmtMoney(
  n: number | string | null | undefined,
  compact = false,
  decimals: number | null = null,
): string {
  if (n === null || n === undefined || n === '') return '—'
  const val = typeof n === 'string' ? Number(n) : n
  if (!isFinite(val)) return '—'
  if (compact && Math.abs(val) >= 10_000) {
    return '$' + new Intl.NumberFormat('en-US', {
      notation: 'compact',
      maximumFractionDigits: 1,
    }).format(val)
  }
  const d = decimals ?? 0
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  }).format(val)
}

export function fmtDate(iso: string | null | undefined, opts?: Intl.DateTimeFormatOptions): string {
  if (!iso) return '—'
  const d = new Date(iso)
  return d.toLocaleString('en-US', opts ?? { month: 'short', day: 'numeric', year: 'numeric' })
}

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  return d.toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: false,
  })
}

export function fmtRelative(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  const now = Date.now()
  const diff = Math.floor((now - d.getTime()) / 1000)
  if (diff < 0) return 'in ' + fmtDuration(-diff)
  return fmtDuration(diff) + ' ago'
}

function fmtDuration(seconds: number): string {
  if (seconds < 60) return `${seconds}s`
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m`
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h`
  if (seconds < 86400 * 30) return `${Math.floor(seconds / 86400)}d`
  if (seconds < 86400 * 365) return `${Math.floor(seconds / 86400 / 30)}mo`
  return `${Math.floor(seconds / 86400 / 365)}y`
}

/** Card expiry is stored 'YYYY-MM' (matching gateway_payment_profiles)
 *  but reads as MM/YYYY on a card. */
export function fmtCardExpiry(expiry: string | null | undefined): string {
  if (!expiry) return '—'
  const [year, month] = expiry.split('-')
  if (!year || !month) return expiry
  return `${month}/${year}`
}

export function fmtName(first: string | null, last: string | null): string {
  const out = [first, last].filter(Boolean).join(' ').trim()
  return out || '—'
}

export const PUBLICATION_COLORS: Record<string, string> = {
  rc_car_action: '#ff5850',
  model_airplane_news: '#5eeaff',
  flight_journal: '#ffb648',
  diecast: '#b69cff',
}

export function publicationColor(slug: string | null | undefined): string {
  if (!slug) return '#837e73'
  return PUBLICATION_COLORS[slug] ?? '#837e73'
}

export const PUBLICATION_NAMES: Record<string, string> = {
  rc_car_action: 'RC Car Action',
  model_airplane_news: 'Model Airplane News',
  flight_journal: 'Flight Journal',
  diecast: 'Die Cast X',
}

export function publicationName(slug: string | null | undefined): string {
  if (!slug) return '—'
  return PUBLICATION_NAMES[slug] ?? slug
}

export const STATUS_TONES: Record<string, string> = {
  Active: 'text-radar-green',
  Expired: 'text-paper-faint',
  Cancelled: 'text-paper-faint',
  'Bad Debt': 'text-radar-red',
  'Bad Address': 'text-radar-red',
  'On Hold': 'text-amber-glow',
  Deceased: 'text-paper-faint',
  Other: 'text-paper-dim',
}
